import type { ComponentType, SVGProps } from "react";
import { MaterialSymbolsType } from "./MaterialSymbolsType";
import { SellarIconsType } from "./SellarIconsType";

export type SvgIconComponentType = ComponentType<
  SVGProps<SVGSVGElement> & {
    title?: string;
    desc?: string;
  }
>;

export interface MaterialFontIconDefinition {
  kind: "font";
  ligature: string;
  fill: 0 | 1;
}

export type IconDefinition = SvgIconComponentType | MaterialFontIconDefinition;

/**
 * Combined Icon Type mapping.
 *
 * To add new icons:
 * 1. Find the icon at https://fonts.google.com/icons
 * 2. Add it to MaterialSymbolsType.ts
 *
 * @see README.md in this directory for more details.
 */
export const IconType = {
  ...MaterialSymbolsType,
  ...SellarIconsType,
};

export type IconType = keyof typeof IconType;
